import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";

type EntityBreadcrumbAction = "create" | "edit" | "view" | "details";

type BuildEntityBreadcrumbsArgs = {
  /** i18n key for the sidebar section (e.g. "businessSetup" | "general") */
  sectionLabelKey?: string;
  /** i18n key for the module (e.g. "accounts" | "units") */
  moduleLabelKey: string;
  /** List route for the module (e.g. "/accounts") */
  moduleHref: string;
  /** Saved entity display name — not live form value */
  entityLabel?: string | null;
  /** Fallback i18n key when entityLabel is empty */
  entityFallbackLabelKey?: string;
  action: EntityBreadcrumbAction;
};

/**
 * Section > Module > [Entity] > Action
 * Create: Section > Module > Create
 * Edit:   Section > Module > Entity Name > Edit
 */
export function buildBusinessSetupEntityBreadcrumbs({
  sectionLabelKey = "businessSetup",
  moduleLabelKey,
  moduleHref,
  entityLabel,
  entityFallbackLabelKey,
  action,
}: BuildEntityBreadcrumbsArgs): BreadcrumbItem[] {
  const section: BreadcrumbItem = { labelKey: sectionLabelKey };
  const moduleCrumb: BreadcrumbItem = {
    labelKey: moduleLabelKey,
    href: moduleHref,
  };

  if (action === "create") {
    return [section, moduleCrumb, { labelKey: "create" }];
  }

  const entityCrumb: BreadcrumbItem = {
    labelKey: entityFallbackLabelKey || moduleLabelKey,
    ...(entityLabel ? { label: entityLabel } : {}),
  };

  const actionKey =
    action === "edit" ? "edit" : action === "view" ? "view" : "Details";

  return [section, moduleCrumb, entityCrumb, { labelKey: actionKey }];
}
